// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2XW0p","footer":"ModalError_footer__1Tp0Z"};